/* ZZ product-card image slider — arrows/dots cycle the first 3 images.
   Delegated + capture-phase so an arrow click never triggers the card link. */
(function () {
  function go(box, dir) {
    var slides = box.querySelectorAll('.zz-cardslide');
    if (slides.length < 2) return;
    var i = 0;
    slides.forEach(function (el, idx) { if (el.classList.contains('is-active')) i = idx; });
    var n = (i + dir + slides.length) % slides.length;
    slides[i].classList.remove('is-active');
    slides[n].classList.add('is-active');
    var dots = box.querySelectorAll('.zz-carddot');
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === n); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.zz-cardnav');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var box = btn.closest('[data-zz-slides]');
    if (box) go(box, btn.classList.contains('zz-cardnav--next') ? 1 : -1);
  }, true);
})();
